import { css, styled } from 'styled-components';

export const Root = styled.span<{
    $background?: string;
    $backgroundSize?: number;
    $iconSize: number;
}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    /* background color */
    ${({ $background }) =>
        $background &&
        css`
            background-color: ${$background};
        `}

    /* if we have a circle size, size & round it, then pad for the icon */
  ${({ $backgroundSize, $iconSize }) =>
        $backgroundSize &&
        css`
            width: ${$backgroundSize}px;
            height: ${$backgroundSize}px;
            border-radius: ${$backgroundSize / 2}px;
            /* center the icon by padding equally on all sides */
            padding: ${(($backgroundSize - $iconSize) / 2).toFixed(2)}px;
        `}
`;

export const SvgWrapper = styled.span<{
    $size: number;
}>`
    display: inline-flex;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;

    & > svg {
        display: block;
        width: 100%;
        height: 100%;
    }
`;
